import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import * as XLSX from "xlsx";
import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Tooltip,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TextareaAutosize,
  AppBar,
  Tabs,
  Tab,
  Select,
  Input,
  Box,
  IconButton,
  TablePagination,
  Avatar,
  DialogActions,
} from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import DiamondIcon from "@mui/icons-material/Diamond";
import * as yup from "yup";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { isMobileDevice } from "app/utils/modifyArrayOfObjectsKeys";
// import { formatDate } from '../PartStoneStatus/PartStoneStatus';
import DeleteIcon from "@mui/icons-material/Delete";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { LoadingButton } from "@mui/lab";
import { Link, useNavigate, useParams } from "react-router-dom";
import { a11yProps } from "../partyPayment/partyPayment";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import EditIcon from "@mui/icons-material/Edit";
import Draggable from "react-draggable";

import Div from "@jumbo/shared/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import ExcelFileUpload from "@jumbo/shared/ExcelUpload/ExcelUpload";
import { formatDateYYYYMMDD } from "app/utils/appHelpers";
import { Close, Download } from "@mui/icons-material";
import { BACKEND_APP_URL } from "app/utils/constants/paths";
import moment from "moment";
const inwardvalidationSchema = yup.object().shape({
  FL_TRANS_DATE: yup.string().required("Transaction Date is required"),
  FL_TRANS_TYPE: yup.string().required("Transaction Type is required"),
  FL_PARTY_CODE: yup.string().required("Party Code is required"),
  FL_TO_ACH_CODE: yup.string().required("Bank is required"),
  FL_TERM_CODE: yup.string().required("Term Code is required"),
  FL_SHIP_BY: yup.string().required("Shipping By is required"),
  FL_BILL_NO: yup.string().required("Bill No is required"),
  FL_CURR_CODE: yup.string().required("Currency Code is required"),
  FL_CONV_RATE: yup.number().required("Conversion Rate is required"),
  FL_DIAMOND_TYPE: yup.string().required("Diamond Type is required"),
  FL_BUSINESS_TYPE: yup.string().required("Business Type is required"),
  // narration: Yup.string().required('Narration is required'),
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const validationSchema = yup.object({
  cledger: yup.object().required("Ledger is required").nullable(),

  date: yup.string().required("Date is required"),
  S_BILL_NO: yup.string().required("Bill no is required"),
  S_BILL_DATE: yup.string().required("Bill date is required"),
  expdetRow: yup.array().of(
    yup.object().shape({
      ledgername: yup.string().required("Debit Ledger Name is required"),
      description: yup.string().required("Description is required"),
      debitAmount: yup
        .number()
        .required("Debit Amount is required")
        .min(1, "Debit Amount must be greater than 0"),
    })
  ),
});
const outwardvalidationSchema = yup.object().shape({
  FL_PARTY_CODE: yup.string().required("PARTY CODE is required"),
  FL_BANK_CODE: yup.string().required("BANK CODE is required"),
  FL_CURR_CODE: yup.string().required("CURRENCY is required"),
  FL_CONV_RATE: yup
    .number()
    .required("CONV RATE is required")
    .positive("CONV RATE must be a positive number"),
  FL_TERM_CODE: yup.string().required("TERM CODE is required"),
  FL_DIAMOND_TYPE: yup.string().required("DIAMOND TYPE is required"),
  FL_SHIP_BY: yup.string().required("SHIP BY is required"),
  FL_TRANS_DATE: yup
    .date()
    .required("TRANS DATE is required")
    .typeError("TRANS_DATE must be a valid date"),
});
const Expensebill = () => {
  const navigate = useNavigate();
  // const [value, setValue] = React.useState({bank:null,date:null,Rate:null,narration:''});
  const [invoiceData, setinvoiceData] = React.useState(null);
  const [selectedinvoiceData, setSelectedinvoiceData] = React.useState(null);
  const [invoicePaidAMT, setinvoicePaidAMT] = React.useState({});
  const [expdetRow, setExpdetRow] = useState([
    { ledgername: null, description: "", debitAmount: "" },
    { ledgername: null, description: "", debitAmount: "" },
    { ledgername: null, description: "", debitAmount: "" },
    { ledgername: null, description: "", debitAmount: "" },
    { ledgername: null, description: "", debitAmount: "" },
    { ledgername: null, description: "", debitAmount: "" },
  ]);
  const [selecedsummrydata, setSelecedsummrydata] = useState({});
  const [helperdata, sethelperdata] = useState(null);
  const [SUMDATA, setSUMDATA] = useState(null);
  const isMobile = isMobileDevice();
  const jumboco = useJumboAuth();
  const swal = useSwalWrapper();
  const { billID } = useParams();
  useEffect(() => {
    setSUMDATA({
      totalamt: expdetRow.reduce(
        (acc, obj) => acc + Number(obj.debitAmount),
        0
      ),
    });
    //consolelog(expdetRow);
  }, [expdetRow]);

  const init = async () => {
    await jwtAuthAxios
      .post("/acc/getleadgerdetail", { tono: [185], grpno: "4" })
      .then((res) => {
        sethelperdata(res.data);
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: e,
        });
      });
  };

  // useEffect(async()=>{
  //   if(value?.partyID){
  //   setinvoiceData([])
  //   setSelectedinvoiceData(null)
  //    await jwtAuthAxios.get('/acc/getpartypurchaseinvoice?party='+value?.partyID.P_CODE).then(res=>{
  //     setinvoiceData(res.data?.data)
  //   }).catch(e=>{
  //     setinvoiceData(null)
  //     setSelectedinvoiceData(null)
  //     swal.fire({
  //       icon:"error",
  //       text:e
  //     })
  //   })}
  // },[value?.partyID])

  const handleSubmit = async (values, { setSubmitting }) => {
    let validationexpdetRow = expdetRow.filter((o) =>
      o.ledgername && o.description && o.debitAmount > 0
        ? false
        : o.ledgername || o.description || o.debitAmount > 0
        ? 1
        : false
    );
    let fdata = expdetRow.filter(
      (o) => o.ledgername && o.description && o.debitAmount > 0
    );

    if (validationexpdetRow.length > 0) {
      alert("One of Yore field is empty in description");
      return;
    } else if (fdata.length == 0) {
      alert("Please Enter description");
    } else {
      await jwtAuthAxios
        .post(
          billID ? `acc/expenseBillEntry/${billID}` : "acc/expenseBillEntry",
          {
            ...values,
            CURR_RATE: values?.CURR_RATE || jumboco?.curr?.Rate,
            expDetail: fdata,
          }
        )
        .then((res) => {
          swal.fire({
            icon: "success",
            text: res.data.message,
          });
          navigate("/acc/goodstransaction");
        })
        .catch(() =>
          swal.fire({
            icon: "error",
            text: "something Went Wrong",
          })
        );
      // Perform form submission logic here
      setSubmitting(false);
    }
  };

  const [initialValues, setinitialValues] = useState({
    cledger: null,
    date: "",
    S_BILL_NO: "",
    S_BILL_DATE: "",
    narration: "",
    CURR_RATE: "",
  });
  const formikRef = useRef();
  // console.log(formikRef.current);
  useEffect(async () => {
    init();
  }, []);
  useEffect(async () => {
    if (formikRef.current) {
      //consolelog("formikRef", formikRef.current.setFieldValue);
      // alert()
      // console.log(helperdata?.toData.filter(e => e.ACODE == res.data?.master?.FL_DRAC));
      billID &&
        formikRef.current.setFieldValue &&
        helperdata &&
        (await jwtAuthAxios
          .get(`acc/getentrydetails?no=${billID}&type=E`)
          .then(async (res) => {
            //  console.log(helperdata?.toData.filter(e => e.ACODE == res.data?.master?.FL_CRAC)[0] );
            await formikRef.current.setFieldValue(
              "cledger",
              await helperdata?.toData.filter(
                (e) => e.ACODE == res.data?.master?.FL_CRAC
              )[0]
            );
            await formikRef.current.setFieldValue(
              "date",
              res.data?.master?.FL_TRANS_DATE?.split?.("T")[0]
            );
            await formikRef.current.setFieldValue(
              "S_BILL_DATE",
              res.data?.master?.FL_BILL_DATE?.split?.("T")[0]
            );
            await formikRef.current.setFieldValue(
              "CURR_RATE",
              res.data?.master?.FL_CONV_RATE
            );
            await formikRef.current.setFieldValue(
              "narration",
              res.data?.master?.FL_NARRATION
            );
            // console.log(res.data?.master?.FL_BILL_NO);
            await formikRef.current.setFieldValue(
              "S_BILL_NO",
              res.data?.master?.FL_BILL_NO
            );
            // setinitialValues({...initialValues,S_BILL_NO:res.data?.master?.FL_BILL_NO})
            // setinitialValues({S_BILL_NO:res.data?.master?.FL_BILL_NO,cledger:res.data?.master?.FL_DRAC,date:res.data?.master?.FL_TRANS_DATE,S_BILL_DATE:res.data?.master?.FL_BILL_DATE,CURR_RATE:res.data?.master?.FL_CONV_RATE,narration:res.data?.master?.FL_NARRATION})
            let tmpobj = res.data?.details.map((de) => {
              //consolelog(de.FL_DR_AC);
              return {
                ledgername: helperdata?.grpleadgerAll.filter(
                  (e) => e.ACODE == de.FL_DR_AC
                )[0],
                description: de?.FL_DESCRIPTION,
                debitAmount: de?.FL_AMT2,
                ...de,
              };
            });
            setExpdetRow(tmpobj);
          })
          .catch((e) => {}));
    }
  }, [formikRef, billID, helperdata]);
  const handlePaymentValidation = () => {
    // Perform payment validation logic here
  };
  const handleAddRow = () => {
    setExpdetRow([
      ...expdetRow,
      { ledgername: null, description: "", debitAmount: "" },
    ]);
  };

  const handleRemoveRow = (index) => {
    //consolelog(index);
    const updatedexpdetRow = [...expdetRow];
    updatedexpdetRow.splice(index, 1);
    setExpdetRow(updatedexpdetRow);
  };

  return helperdata == null && initialValues == false ? (
    "Loading...." //<JumboCardQuick title={'Expense Bill'} >
  ) : (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      innerRef={formikRef}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, setFieldValue, values, errors }) => (
        <Form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
          <Typography variant="h4" mb={2}>
            Expense Bill
          </Typography>
          <Grid container spacing={2}>
            <Grid item lg={6} xs={12}>
              <FormControl fullWidth>
                <Autocomplete
                  value={values?.cledger}
                  fullWidth
                  onChange={(event, newValue) => {
                    setFieldValue("cledger", newValue);
                  }}
                  defaultValue={values?.cledger}
                  options={helperdata?.toData || []}
                  getOptionLabel={(option) => option?.ANAME || ""} // Specify the property to use as the display value
                  renderInput={(params) => (
                    <TextField {...params} label="Credit ledger" />
                  )}
                />

                {/* <Field
                  name="cledger"
                  as={Autocomplete}
                  options={helperdata?.toData}
                  getOptionLabel={(option) => option?.ANAME || ''}
                  renderInput={(params) => <TextField {...params} label="Credit ledger" />}
                /> */}
                <ErrorMessage
                  name="cledger"
                  component="div"
                  className="error"
                />
              </FormControl>
            </Grid>
            <Grid item lg={4.5} xs={12}>
              <Field
                name="date"
                as={TextField}
                fullWidth
                type="date"
                label="Date"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
              <ErrorMessage name="date" component="div" className="error" />
            </Grid>
            <Grid item lg={1.5} xs={12}>
              <FormControl fullWidth>
                <InputLabel htmlFor="outlined-adornment-amount">
                  Conversion Rate
                </InputLabel>
                <OutlinedInput
                  // value={values.amount}
                  onChange={(e) => setFieldValue("CURR_RATE", e.target.value)}
                  type="number"
                  startAdornment={
                    <InputAdornment position="start">
                      {jumboco?.curr?.cd}
                    </InputAdornment>
                  }
                  value={values?.CURR_RATE || jumboco?.curr?.Rate}
                  label="Conversion Rate"
                />
              </FormControl>
            </Grid>
            <Grid item lg={4} xs={12}>
              <Field
                name="S_BILL_NO"
                as={TextField}
                label="Supplier Bill NO"
                fullWidth
                value={values?.S_BILL_NO}
                variant="outlined"
              />
              <ErrorMessage
                name="S_BILL_NO"
                component="div"
                className="error"
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <Field
                name="S_BILL_DATE"
                as={TextField}
                fullWidth
                type="date"
                label="Supplier Bill date"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              />
              <ErrorMessage
                name="S_BILL_DATE"
                component="div"
                className="error"
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              {/* Add Autocomplete Field for invoiceData */}
            </Grid>
          </Grid>
          <Stack direction="row" justifyContent={"space-between"} mb={1}>
            <Typography variant={"h5"}>Description</Typography>
            <Button size="small" variant="contained" onClick={handleAddRow}>
              Add New Description
            </Button>
          </Stack>
          <Divider sx={{ mb: 2 }} />
          {/* <Grid container spacing={2}> */}
          <Table border={0}>
            {expdetRow.map((row, index) => (
              // <React.Fragment key={index}>
              <TableRow>
                <TableCell sx={{ p: 0 }}>
                  {/* <Grid item xs={4}> */}
                  <FormControl fullWidth>
                    <Autocomplete
                      // value={row.ACODE || '`'}
                      size="small"
                      sx={{ minWidth: "200px" }}
                      options={helperdata?.grpleadgerAll || []}
                      getOptionLabel={(option) => option?.ANAME || ""}
                      value={row?.ledgername}
                      onChange={(event, newValue) => {
                        const updatedRows = [...expdetRow];
                        updatedRows[index].ledgername = newValue || "";
                        setExpdetRow(updatedRows);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Debit Ledger Name" />
                      )}
                    />
                  </FormControl>
                  {/* </Grid> */}
                </TableCell>
                <TableCell sx={{ p: 1 }}>
                  {/* <Grid item xs={4}> */}
                  <TextField
                    fullWidth
                    size="small"
                    value={row.description}
                    onChange={(event) => {
                      const updatedRows = [...expdetRow];
                      updatedRows[index].description = event.target.value;
                      setExpdetRow(updatedRows);
                    }}
                    label="Description"
                  />
                  {/* </Grid>
          <Grid item xs={3}> */}
                </TableCell>
                <TableCell sx={{ p: 0 }}>
                  <TextField
                    fullWidth
                    size="small"
                    value={row.debitAmount}
                    onChange={(event) => {
                      const updatedRows = [...expdetRow];
                      updatedRows[index].debitAmount = event.target.value;
                      setExpdetRow(updatedRows);
                    }}
                    inputProps={{ min: 1 }}
                    type="number"
                    label={`Debit Amount(${jumboco?.curr?.cd})`}
                  />
                  {/* </Grid>
          <Grid item xs={1}> */}
                </TableCell>
                {/* <TableCell sx={{p:0,textAlign: 'end'}} >
            <Tooltip title="Remove"><Fab color='error' variant="contained" onClick={() => handleRemoveRow(index)} size='small'><DeleteOutlineOutlinedIcon /></Fab>
            </Tooltip>
          </TableCell> */}
                {/* </Grid> */}
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={2}>
                <Typography variant={"h4"}>Total</Typography>
              </TableCell>
              <TableCell>{SUMDATA?.totalamt}</TableCell>
            </TableRow>
          </Table>
          {/* </React.Fragment> */}
          {/* </Grid> */}
          <TextareaAutosize
            minRows={5}
            onInput={(e) => setFieldValue("narration", e.target.value)}
            name="narration"
            placeholder="NARRATION"
            defaultValue={values?.narration}
            style={{ width: "100%", marginTop: "50px" }}
          />
          <LoadingButton
            // disabled={isSubmitting || selectedinvoiceData?.length <= 0}
            // onClick={handlePaymentValidation}
            type="submit"
            variant="contained"
            sx={{ mt: 2, ml: "auto", display: "block" }}
          >
            Submit
          </LoadingButton>
        </Form>
      )}
    </Formik>
  );
  // </JumboCardQuick>
};

const InwardBook = ({ FRMVAL }) => {
  const [view, setView] = useState(null);
  const [currentType, setCurrentType] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [page, setPage] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [totalWeight, setTotalWeight] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [Data, setData] = useState(null);
  const [mdata, setmdatah] = useState(null);
  const [excelfile, setExcelfile] = useState(null);
  const [updatedStone, setUpdatedStone] = useState([]);
  const [insertedStone, setInserteddStone] = useState([]);
  const [removableStone, setRemovableStone] = useState([]);
  const [initialValues, setInitialValues] = useState({
    FL_TRANS_DATE: FRMVAL?.master?.FL_TRANS_DATE
      ? formatDateYYYYMMDD(FRMVAL?.master?.FL_TRANS_DATE)
      : "",
    FL_TRANS_TYPE: FRMVAL?.master?.FL_TRANS_TYPE || "",
    FL_TO_ACH_CODE: FRMVAL?.master?.FL_BANK_CODE || "",
    FL_PARTY_CODE: FRMVAL?.master?.FL_PARTY_CODE || "",
    FL_TERM_CODE: FRMVAL?.master?.FL_TERM_CODE || "",
    FL_SHIP_BY: FRMVAL?.master?.FL_SHIP_BY || "",
    FL_CURR_CODE: FRMVAL?.master?.FL_CURR_CODE || "",
    FL_CONV_RATE: FRMVAL?.master?.FL_CONV_RATE || "",
    FL_BILL_NO: FRMVAL?.master?.FL_BILL_NO || "",
    FL_DIAMOND_TYPE: FRMVAL?.master?.FL_DIAMOND_TYPE || "",
    FL_BUSINESS_TYPE: FRMVAL?.master?.FL_BUSINESS_TYPE || "",
    FL_BROKER_PER: FRMVAL?.master?.FL_BROKER_PER || "",
    FL_ADAT_FLG: FRMVAL?.master?.FL_ADAT_FLG || "",
    FL_NARRATION: FRMVAL?.master?.FL_NARRATION || "",
    FL_BROKER_PARTY: FRMVAL?.master?.FL_BROKER_PARTY || "",
  });
  
  // Fetch the branch data
  const [tableData, setTableData] = useState(FRMVAL?.details || []);
  const columns = [
    {
      accessorKey: "FL_STONE_ID",
      grow: true,
      header: "STONE",
      enableEditing: true,
    },
    {
      accessorKey: "FL_SHAPE",
      grow: true,
      header: "SHAPE",
      enableEditing: true,
    },
    {
      accessorKey: "FL_COLOR",
      grow: true,
      header: "COLOR",
      enableEditing: true,
    },
    {
      accessorKey: "FL_CLARITY",
      grow: true,
      header: "CLARITY",
      enableEditing: true,
    },
    {
      accessorKey: "FL_CARATS",
      grow: true,
      header: "CARATS",
      enableEditing: true,
    },
    { accessorKey: "FL_RAP", grow: true, header: "RAP", enableEditing: true },
    { accessorKey: "FL_DISC", grow: true, header: "DISC", enableEditing: true },
    {
      accessorKey: "FL_PRICE",
      grow: true,
      header: "PRICE",
      enableEditing: false,
      Cell: (params) => {
        return (
          (
            (params.row.original?.FL_RAP *
              (100 - params.row.original?.FL_DISC)) /
            100
          )?.toFixed(2) || 0
        );
      },
    },
    { accessorKey: "FL_SRNO", grow: true, header: "no", enableEditing: false },
  ];
  const columnVirtualizerInstanceRef = useRef(null);
  const openDeleteConfirmModal = (row) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      // deleteUser(row.original.id);
      setRemovableStone([...removableStone, row.id]);
      let UPDOBJ = tableData.filter((item) => item.FL_STONE_ID !== row.id);
      setTableData(UPDOBJ);
    }
  };
  const table = useMaterialReactTable({
    columnVirtualizerInstanceRef, //optional
    columnVirtualizerOptions: { overscan: 4 }, //optionally customize the virtualizer
    columns: columns, //500 columns
    data: tableData,
    density: "spacious",
    layoutMode: "semantic",
    enableRowActions: true,
    // enableEditing: true,
    selectAllMode: true,
    // initialState: { columnVisibility: { no: false } },
    onCreatingRowSave: async (e) => {
      // console.log(e);
      setInserteddStone([...insertedStone, e.values.FL_STONE_ID]);
      setTableData([
        { FL_SRNO: "new-" + e.values.FL_STONE_ID, ...e.values },
        ...tableData,
      ]);
      // e.exitEditingMode(true)
      table.setCreatingRow(false);
      // console.log(e);
    },
    onEditingRowSave: async (e) => {
      //consolelog(e);
      setUpdatedStone([...updatedStone, e.values.FL_STONE_ID]);
      let UPDOBJ = tableData.map((i) => {
        if (i.FL_STONE_ID == e.values.FL_STONE_ID) {
          return e.values;
        } else {
          return i;
        }
      });
      setTableData(UPDOBJ);
      e.exitEditingMode(true);
      // console.log(e);
    },
    getRowId: (row) => row.FL_STONE_ID,
    renderRowActionMenuItems: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    // onEditingRowChange: (rowIndexes) => console.log(rowIndexes),
    // enableColumnPinning: true,
    enableColumnResizing: true,
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          //or you can pass in a row object to set default values with the `createRow` helper function
          // table.setCreatingRow(
          //   createRow(table, {
          //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
          //   }),
          // );
        }}
      >
        Add New Record
      </Button>
    ),
  });
  useEffect(() => {
    async function fetchMdata() {
      try {
        const { data } = await jwtAuthAxios.get(
          "master/helper?term=1&paramsData=SHIPPEDBY,OUR_BUSINESS_TYPE&Vendor=1&broker=1&curr=1&inventoryType=1&trtype=INWARD&leadgerdetail=22"
        );
        setmdatah(data.data);
      } catch (error) {
        // Handle the error
      }
    }
    fetchMdata();
  }, []);

  const handleFormSubmit = async (values) => {
    // console.log(values); return
    if (openModal) return;
    if (excelfile == null && !FRMVAL) {
      swal.fire({
        icon: "error",
        text: "Please Upload File",
      });
    } else {
      // console.log(values);
      let formData;
      if (FRMVAL) {
        // formData.append('FromBranch', values.FromBranch);
        // formData.append('jangadDate', values.jangadDate);
        formData = {
          FL_ADAT_FLG: values.FL_ADAT_FLG,
          FL_BILL_NO: values.FL_BILL_NO,
          FL_BROKER_PARTY: values.FL_BROKER_PARTY,
          FL_BROKER_PER: values.FL_BROKER_PER,
          FL_BUSINESS_TYPE: values.FL_BUSINESS_TYPE,
          FL_CONV_RATE: values.FL_CONV_RATE,
          FL_TO_ACH_CODE: values.FL_TO_ACH_CODE,
          FL_CURR_CODE: values.FL_CURR_CODE,
          FL_DIAMOND_TYPE: values.FL_DIAMOND_TYPE,
          FL_PARTY_CODE: values.FL_PARTY_CODE,
          FL_SHIP_BY: values.FL_SHIP_BY,
          FL_TERM_CODE: values.FL_TERM_CODE,
          FL_TRANS_DATE: values.FL_TRANS_DATE,
          FL_TRANS_NO: values.FL_TRANS_NO,
          FL_TRANS_TYPE: values.FL_TRANS_TYPE,
          FL_NARRATION: values.FL_NARRATION,
          FL_INVENTORY_TYPE: values.FL_INVENTORY_TYPE,
          detval: tableData?.filter((d) =>
            updatedStone.includes(d.FL_STONE_ID)
          ),
          detinseval: tableData?.filter((d) =>
            insertedStone.includes(d.FL_STONE_ID)
          ),
          detvalDel: removableStone,
        };
        // formData.append('detval',tableData)
        //  formData.append('detvalDel',removableStone)
      } else {
        formData = new FormData();
        formData.append("excelfile", excelfile);
        await Object.keys(values).map((item) =>
          formData.append(item, values[item])
        );
      }
      // Object.keys(values).map(item => console.log(item, values[item]))
      setLoading(true);

      // Make the API call with the Excel data
      let url = FRMVAL?.master?.FL_TRANS_NO
        ? `acc/polishInward/edit/${FRMVAL?.master?.FL_TRANS_NO}`
        : "acc/polishInward";
      jwtAuthAxios
        .post(url, formData)
        .then((response) => {
          // console.log(response.data);
          if (response.data.status == "success") {
            swal.fire({
              icon: "success",
              text: response.data.message,
            });
            navigate("/acc/goodstransaction");
          } else {
            swal.fire({
              icon: "error",
              text: response.data.message,
            });
          }
          // response.data.status == 'success' && navigate('/stock')
        })
        .catch((error) => {
          swal.fire({
            icon: "error",
            text: "Internal server error",
          });
        })
        .finally((e) => {
          setLoading(false);
        });
    }
    // reader.readAsBinaryString(excelfile);
    // }

    return false;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const displayData = excelData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };
  const handleShowJsonData = async () => {
    if (excelfile == null) {
      swal.fire({
        icon: "error",
        text: "Please Upload File",
      });
    } else {
      // Convert Excel data to JSON
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        setExcelData(jsonData);
        setPage(0); // Reset to the first page
      };
      reader.readAsBinaryString(excelfile);
      setOpenModal(true);
      const sum = await excelData.reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue["CARATS"]);
      }, 0);
      setTotalWeight(sum.toFixed(3));
    }
  };
  const swal = useSwalWrapper();

  return (
    <>
      <Stack justifyContent={"end"} direction={"row"} spacing={2}>
        <Tooltip title="DownLoad Parcel Sample file">
          <Link
            to={`${BACKEND_APP_URL}demo/ACC_DIAMOND_INWARD_SHEET_POLISH_PARCEL.xlsx`}
            target="_blank"
          >
            <Avatar>
              <Download />
            </Avatar>
          </Link>
        </Tooltip>
        <Tooltip title="DownLoad Single Sample file">
          <Link
            to={`${BACKEND_APP_URL}demo/ACC_DIAMOND_INWARD_SHEET.xlsx`}
            target="_blank"
          >
            <Avatar>
              <DiamondIcon />
            </Avatar>
          </Link>
        </Tooltip>
      </Stack>
      <Formik
        initialValues={initialValues}
        validationSchema={inwardvalidationSchema}
        onSubmit={handleFormSubmit}
        // onSubmit={(e)=>e.key !== 'Enter' && handleFormSubmit(e)}
      >
        {({ isSubmitting, errors, touched, handleChange, values }) =>
          mdata != null && (
            <Form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              style={{ display: "block", width: "100%" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <InputLabel>Transaction Type</InputLabel>
                  <Field
                    size="small"
                    name="FL_TRANS_TYPE"
                    disabled={values?.FL_TRANS_NO}
                    InputLabel="Transaction Type"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Transaction Type</MenuItem>
                    {mdata?.TRANSATION_TYPE.map((item) => (
                      <MenuItem value={item.FL_GPID}>
                        {item.FL_PARA_VALUE}
                      </MenuItem>
                    ))}
                  </Field>
                  {errors.FL_TRANS_TYPE && touched.FL_TRANS_TYPE && (
                    <div className="error">{errors.FL_TRANS_TYPE}</div>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <InputLabel>Transaction Date</InputLabel>
                  <JumboTextField
                    size="small"
                    fullWidth
                    name="FL_TRANS_DATE"
                    type="date"
                  />
                </Grid>
                <Grid item xs={4}>
                  <InputLabel>Select Business type</InputLabel>
                  <Field
                    size="small"
                    name="FL_BUSINESS_TYPE"
                    InputLabel="Select Business"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Business</MenuItem>
                    {mdata?.OUR_BUSINESS_TYPE.map((item) => (
                      <MenuItem value={item.FL_GPID}>
                        {item.FL_PARA_VALUE}
                      </MenuItem>
                    ))}
                  </Field>
                  {errors.FL_BUSINESS_TYPE && touched.FL_BUSINESS_TYPE && (
                    <div className="error">{errors.FL_BUSINESS_TYPE}</div>
                  )}
                </Grid>
                <Grid item xs={5}>
                  <InputLabel>Select Party</InputLabel>
                  <Field
                    size="small"
                    name="FL_PARTY_CODE"
                    InputLabel="Select Party"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Party</MenuItem>
                    {mdata?.VENDOR.map((item) => (
                      <MenuItem value={item.FL_PARTY_CODE}>
                        {item.FL_PARTY_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                  {errors.FL_PARTY_CODE && touched.FL_PARTY_CODE && (
                    <div className="error">{errors.FL_PARTY_CODE}</div>
                  )}
                </Grid>
                <Grid item xs={5}>
                  <InputLabel>Select Bank</InputLabel>
                  <Field
                    size="small"
                    name="FL_TO_ACH_CODE"
                    InputLabel="Select Bank"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Bank</MenuItem>
                    {mdata?.leadgerdetail?.map((item) => (
                      <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                    ))}
                  </Field>
                  {errors.FL_TO_ACH_CODE && touched.FL_TO_ACH_CODE && (
                    <div className="error">{errors.FL_TO_ACH_CODE}</div>
                  )}
                </Grid>
                <Grid item xs={2}>
                  <InputLabel>Select Term</InputLabel>
                  <Field
                    size="small"
                    name="FL_TERM_CODE"
                    InputLabel="Select Term"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Term</MenuItem>
                    {mdata?.TERM.map((item) => (
                      <MenuItem value={item.FL_TERM_CODE}>
                        {item.FL_TERM_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                  {errors.FL_TERM_CODE && touched.FL_TERM_CODE && (
                    <div className="error">{errors.FL_TERM_CODE}</div>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <InputLabel>Select Ship type</InputLabel>
                  <Field
                    size="small"
                    name="FL_SHIP_BY"
                    InputLabel="Select Ship type"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Ship type</MenuItem>
                    {mdata?.SHIPPEDBY.map((item) => (
                      <MenuItem value={item.FL_GPID}>
                        {item.FL_PARA_VALUE}
                      </MenuItem>
                    ))}
                  </Field>
                  {errors.FL_SHIP_BY && touched.FL_SHIP_BY && (
                    <div className="error">{errors.FL_SHIP_BY}</div>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <InputLabel>Select Curr type</InputLabel>
                  <Field
                    size="small"
                    name="FL_CURR_CODE"
                    InputLabel="Select Curr"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Curr</MenuItem>
                    {mdata?.CURR.map((item) => (
                      <MenuItem value={item.FL_CURRENCY_ID}>
                        {item.FL_CURRENCY_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                  {errors.FL_CURR_CODE && touched.FL_CURR_CODE && (
                    <div className="error">{errors.FL_CURR_CODE}</div>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputLabel>Currency Rate</InputLabel>
                  <JumboTextField
                    size="small"
                    fullWidth
                    name="FL_CONV_RATE"
                    type="text"
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputLabel>Select INVENTORY type</InputLabel>
                  <Field
                    size="small"
                    name="FL_DIAMOND_TYPE"
                    InputLabel="Select Diamond"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select INVENTORY</MenuItem>
                    {mdata?.INVETORYTYPE.map((item) => (
                      <MenuItem value={item.NAME}>{item.NAME}</MenuItem>
                    ))}
                  </Field>
                  {errors.FL_DIAMOND_TYPE && touched.FL_DIAMOND_TYPE && (
                    <div className="error">{errors.FL_DIAMOND_TYPE}</div>
                  )}
                </Grid>

                <Grid item xs={12} sm={5}>
                  <InputLabel>INVOICE Bill no.</InputLabel>
                  {/* <Field size="small"
            as={TextField}
            name="FL_BILL_NO"
            fullWidth
          /> */}
                  <JumboTextField
                    size="small"
                    fullWidth
                    name="FL_BILL_NO"
                    type="text"
                  />
                </Grid>
                <Grid item xs={5}>
                  <InputLabel>Select Broker</InputLabel>
                  <Field
                    size="small"
                    name="FL_BROKER_PARTY"
                    InputLabel="Select Broker"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Broker</MenuItem>
                    {mdata?.BROKER.map((item) => (
                      <MenuItem value={item.FL_PARTY_CODE}>
                        {item.FL_PARTY_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <InputLabel>Brockrage Rate(%)</InputLabel>
                  {/* <Field size="small"
            as={TextField}
            name="FL_BROKER_PER"
            fullWidth
          /> */}
                  <JumboTextField
                    size="small"
                    fullWidth
                    name="FL_BROKER_PER"
                    type="number"
                  />
                </Grid>
                <Grid
                  item
                  sx={{ display: "flex", alignItems: "center" }}
                  xs={12}
                  sm={2}
                >
                  <Field
                    size="small"
                    component={Checkbox}
                    name="FL_ADAT_FLG"
                    label="Currency Rate"
                    onChange={handleChange}
                    fullWidth
                  />

                  <InputLabel>IS On Adat</InputLabel>
                </Grid>

                <Grid item xs={9}>
                  <InputLabel>Naration</InputLabel>
                  <TextareaAutosize
                    name="FL_NARRATION"
                    label="Naration"
                    minRows={5}
                    style={{ width: "98%" }}
                    onChange={handleChange}
                    fullWidth
                  >
                    {values.FL_NARRATION || ""}
                  </TextareaAutosize>
                  {/* <Field size="small"
            component={TextareaAutosize}      
            /> */}
                </Grid>
                <Grid
                  item
                  sx={{ display: "flex", alignItems: "center" }}
                  justifyContent="end"
                  xs={12}
                  sm={3}
                >
                  {excelfile != null && (
                    <Button
                      variant="outlined"
                      color="primary"
                      disabled={loading}
                      onClick={handleShowJsonData}
                    >
                      show Excel
                    </Button>
                  )}
                </Grid>
                <Grid item xs={12}>
                  {!FRMVAL?.details ? (
                    <ExcelFileUpload
                      onFileUpload={(file) => {
                        setExcelfile(file);
                      }}
                    />
                  ) : (
                    <Paper>
                      {/* {JSON.stringify(columnsdata)} */}
                      <MaterialReactTable table={table} />
                      {/* <DataGrid
            rows={values?.detlist || []}
            columns={columns}
            // apiRef={gridRef}
            // onRowEditStop={(params) => getFieldValue(params)}

            // onEditRowsModelChange={handleEditCellChange}
            // onEditCellChange={handleEditCellChange}
            autoHeight
            getRowId={(row) => row.FL_STONE_ID}
            // rowSelectionModel={SelectedStone}
            // onRowSelectionModelChange={handleStoneSelect}
            // onCellEditCommit={handleCellEditCommit}
            // onCellEditStop={handleCellEditCommit}
            // onRowEditCommit={handleCellEditCommit}

            // isCellEditable={(params) => params.row.STATUS == 'A'}
            // isRowSelectable={(params) => params.row.STATUS == 'A'}
            density='compact'
            editMode='row'
            // getRowId={(row) => row.STONE}
            // checkboxSelection={(params) => params.row.STATUS == 'A'}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 100,
                },
              },
            }}
            // pageSizeOptions={[50]}

            // checkboxSelection
            disableRowSelectionOnClick
          />
             */}
                    </Paper>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <LoadingButton
                    variant="contained"
                    color="primary"
                    type="submit"
                    loading={loading}
                    disabled={isSubmitting && excelfile != null}
                  >
                    Submit
                  </LoadingButton>
                </Grid>
              </Grid>
            </Form>
          )
        }
      </Formik>
      <Dialog fullScreen open={openModal} onClose={handleCloseModal}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h1">Excel Data Preview</Typography>
          <Close sx={{ cursor: "pointer" }} onClick={handleCloseModal} />
        </DialogTitle>
        <DialogContent>
          {excelData.length > 0 && (
            <div>
              <Div
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h4">
                  Total Diamond: {excelData.length} PCS
                </Typography>
                <Typography variant="h4">
                  Total Weight: {totalWeight} CTS{" "}
                </Typography>
              </Div>
              {/* <TableContainer  component={Paper}> */}
              <Table size="small" sx={{ whiteSpace: "nowrap" }}>
                <TableHead>
                  <TableRow>
                    {Object.keys(excelData[0]).map((key) => (
                      <TableCell key={key}>{key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayData.map((row, index) => (
                    <TableRow key={index}>
                      {Object.values(row).map((value, valueIndex) => (
                        <TableCell key={valueIndex}>{value}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {/* </TableContainer> */}

              <TablePagination
                rowsPerPageOptions={[10, 250, 500]}
                component="div"
                count={excelData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const OutwardBook = ({ FRMVAL }) => {
  const navigate = useNavigate();
  const { billID, ETYPE, TRTYPE } = useParams();

  const [open, setOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingItemIndex, setEditingItemIndex] = useState(null);

  const [editedValues, setEditedValues] = useState({});
  const [editedItemvalues, setEditedItemvalues] = useState({});

  const swal = useSwalWrapper();
  const [editabletrdetail, setEditabletrdetail] = useState(null);
  const [stoneDetail, setStoneDetail] = useState([]);
  const [jeweleryDetail, setJeweleryDetail] = useState([]);
  const [advanvedPaidamt, setadvanvedPaidamt] = useState({});
  const [stoneDetailEgerDetails, setStoneDetailEgerDetails] = useState({});
  const formikRef = useRef();

  const jumboco = useJumboAuth();
  const [initialValues, setInitialValues] = useState({
    FL_TRANS_DATE: FRMVAL?.master?.FL_TRANS_DATE
      ? formatDateYYYYMMDD(FRMVAL?.master?.FL_TRANS_DATE)
      : "",
    FL_TRANS_TYPE: FRMVAL?.master?.FL_TRANS_TYPE || "",
    FL_BANK_CODE: FRMVAL?.master?.FL_BANK_CODE || "",
    FL_PARTY_CODE: FRMVAL?.master?.FL_PARTY_CODE || "",
    FL_TERM_CODE: FRMVAL?.master?.FL_TERM_CODE || "",
    FL_SHIP_BY: FRMVAL?.master?.FL_SHIP_BY || "",
    FL_CURR_CODE: FRMVAL?.master?.FL_CURR_CODE || "",
    FL_CONV_RATE: FRMVAL?.master?.FL_CONV_RATE || jumboco?.curr?.Rate,
    FL_DIAMOND_TYPE: FRMVAL?.master?.FL_DIAMOND_TYPE || "POLISH-SINGLE",
    FL_BUSINESS_TYPE: FRMVAL?.master?.FL_BUSINESS_TYPE || "",
    FL_NARRATION: FRMVAL?.master?.FL_NARRATION || "",
  });

  const [advanceData, setAdvanceData] = useState([]);

  const fetchtrPartydata = useCallback(async () => {
    await jwtAuthAxios
      .get(
        "master/helper?party=1&trtype=OUTWARD&inventoryType=1&salesman=1&paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1&tax=VAT_ON_SALES&leadgerdetail=22"
      )
      .then((res) => {
        setEditabletrdetail(res.data.data);
      });
  });

  const fetchAdvanceData = useCallback(async (values) => {
    let url = `acc/getadvancedbil?party=${values.FL_PARTY_CODE}&curr=${values?.FL_CURR_CODE}`;
    if (billID && TRTYPE) {
      url += `&trno=${billID}&trtype=${TRTYPE}`;
    }
    await jwtAuthAxios.get(url).then((res) => {
      if (FRMVAL?.advanced) {
        const tmpObj = {};
        FRMVAL?.advanced.map((el) => {
          tmpObj[el?.TRANSNO] = el.paid_amt;
        });
        const newData = res.data.data.map((element) => {
          const advancedItem = FRMVAL?.advanced?.find(
            (item) => item.TRANSNO === element.FL_TRANSNO
          );

          if (advancedItem) {
            element["OAMT"] =
              Number(element["OAMT"]) + Number(advancedItem?.paid_amt);
            return element;
          } else {
            return element;
          }
        });
        setAdvanceData(newData);
        setadvanvedPaidamt({
          ...advanvedPaidamt,
          ...tmpObj,
        });
      }else
      {
        setAdvanceData(res?.data?.data);
      }
    });
  });

  useEffect(() => {
    fetchtrPartydata();
  }, []);

  useEffect(() => {
    formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY"
      ? FRMVAL &&
        setJeweleryDetail(
          FRMVAL?.details?.map((item) => ({
            FL_STONE_ID: item["FL_STONE_ID"],
            FL_SHAPE: item["FL_SHAPE"],
            FL_COLOR: item["FL_COLOR"],
            FL_RAP: item["FL_RAP"],
            FL_CARATS: item["FL_CARATS"],
            FL_PCS: item["FL_PCS"],
            FL_DISC: item["FL_DISC"],
            FL_AMT1: item["FL_AMT1"],
            FL_AMT2: item["FL_AMT2"],
          }))
        )
      : FRMVAL &&
        setStoneDetail(
          FRMVAL?.details?.map((sdata) => ({
            FL_STONE_ID: sdata["FL_STONE_ID"],
            FL_WGT: sdata["FL_CARATS"],
            FL_RAP_PRICE_US: sdata["FL_RAP"],
            FL_SALEDISC: sdata["FL_DISC"],
            FL_SALERATE: sdata["FL_PRICE"],
            FL_AMT1: sdata["FL_AMT1"],
            FL_AMT2: sdata["FL_AMT2"],
          }))
        );
  }, [FRMVAL]);

  const HandleRemoveCell = (index) => {
    setStoneDetail(stoneDetail.filter((sd) => sd.FL_STONE_ID != index));
  };
  const HandleItemRemoveCell = (index) => {
    setJeweleryDetail(jeweleryDetail.filter((sd) => sd.FL_STONE_ID != index));
  };
  const handleCellDoubleClick = (index, field, value) => {
    setEditingIndex(index);
    setEditedValues({ ...editedValues, [field]: value });
  };

  const handleItemCellDoubleClick = (index, field, value) => {
    setEditingItemIndex(index);
    setEditedItemvalues({ ...editedItemvalues, [field]: value });
  };

  const handleInputChange = (field, value) => {
    setEditedValues({ ...editedValues, [field]: value });
  };

  const handleItemInputChange = (field, value) => {
    setEditedItemvalues({ ...editedItemvalues, [field]: value });
  };
  const handleSaveButtonClick = () => {
    // Reverse calculate the values based on the edited FL_AMT2
    // You need to implement your calculation logic here
    // let stone= stoneDetail?.filter(s=>s.FL_STONE_ID==editingIndex)[0];
    // console.log(stone);
    // let amt1= Number(editedValues?.FL_AMT2)/editabletrdetail?.FL_CONV_RATE
    // let salerate= amt1/stone.FL_WGT
    // console.log(
    //   {FL_AMT1:amt1,
    //   FL_SALERATE: salerate,
    //   FL_SALEDISC:100-( salerate*100/ stone?.FL_RAP_PRICE_US)
    //   }
    // );

    let Std = stoneDetail.map((sd) => {
      if (sd.FL_STONE_ID == editingIndex) {
        // alert()
        return {
          ...sd,
          FL_AMT2: Number(editedValues?.FL_AMT2),
          FL_AMT1:
            Number(editedValues?.FL_AMT2) / editabletrdetail?.FL_CONV_RATE,
          FL_SALERATE:
            Number(editedValues?.FL_AMT2) /
            editabletrdetail?.FL_CONV_RATE /
            sd.FL_WGT,
          FL_SALEDISC:
            100 -
            ((Number(editedValues?.FL_AMT2) /
              editabletrdetail?.FL_CONV_RATE /
              sd.FL_WGT) *
              100) /
              sd?.FL_RAP_PRICE_US,
        };
      } else {
        return sd;
      }
    });
    //consolelog(Std);
    setStoneDetail(Std);
    // console.log('Edited values:', editedValues?.FL_AMT2,editabletrdetail?.FL_CONV_RATE);

    // Clear editing state
    setEditingIndex(null);
    setEditedValues({});
  };

  const handleSaveItemButtonClick = () => {
    let item = jeweleryDetail.map((it) => {
      if (it.FL_STONE_ID == editingItemIndex) {
        return {
          ...it,
          FL_AMT2: Number(editedItemvalues?.FL_AMT2),
          FL_AMT1:
            Number(editedItemvalues?.FL_AMT2) /
            formikRef.current.values?.FL_CONV_RATE,
        };
      } else {
        return it;
      }
    });
    setJeweleryDetail(item);
    setEditingItemIndex(null);
    setEditedItemvalues({});
  };

  const handleSubmitData = async (val) => {
    const updatedAdvanceData = advanceData
      ?.flatMap((item) =>
        Object.keys(advanvedPaidamt)?.map((i) =>
          item?.FL_TRANSNO == i
            ? { ...item, paid_amt: advanvedPaidamt[i] }
            : false
        )
      )
      .filter((item) => item !== false);
    //consolelog("updatedAdvanceData", updatedAdvanceData);
    await jwtAuthAxios
      .post(billID ? "acc/polishoutward/" + billID : "acc/polishoutward", {
        ...val,
        FL_WAT_PER: editabletrdetail?.TAX?.FL_TAX_PER,
        DET_DATA:
          formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY"
            ? jeweleryDetail
            : stoneDetail,
        advancedData: updatedAdvanceData,
        FL_TRANS_TYPE: 35,
      })
      .then((res) => {
        swal.fire({
          icon: "success",
          text: res.data.message,
        });
        navigate("/acc/goodstransaction");
        // setOpen(false)
      })
      .catch((e) =>
        swal.fire({
          icon: "error",
          text: e,
        })
      );
  };

  const addstoneHandler = async () => {
    let stonID = await prompt("Please Enter Stone ID");
    if (stonID) {
      await jwtAuthAxios
        .post("acc/stoneUser", {
          stone: stonID.split(","),
          diamondType: formikRef?.current?.values?.FL_DIAMOND_TYPE,
        })
        .then((res) => {
          let stonefilter = res.data?.result?.filter((s) => s.FL_STATUS != "A");
          if (stonefilter > 0) {
            alert(
              stonefilter?.map((s) => s.FL_STATUS).join(",") +
                "Stone is not available"
            );
          } else {
            let obj = res.data?.result?.map((stone) => ({
              ...stone,
              TYPE: "NEW",
              FL_STONE_ID: stone?.FL_STONE_ID,
              FL_WGT: stone?.FL_CARATS,
              FL_RAP_PRICE_US: stone?.FL_RAP_PRICE_US,
              FL_SALEDISC: stone?.ASK_DISC,
              FL_AMT2:
                ((stone?.FL_RAP_PRICE_US * (100 - stone?.ASK_DISC)) / 100) *
                stone?.FL_CARATS *
                formikRef.current.values?.FL_CONV_RATE,
            }));
            setStoneDetail([...stoneDetail, ...obj]);
          }
        });
    }
  };

  const addItemHandler = async () => {
    let stonID = await prompt("Please Enter Item Code");
    if (stonID) {
      await jwtAuthAxios
        .post("acc/stoneUser", {
          stone: stonID.split(","),
          diamondType: formikRef?.current?.values?.FL_DIAMOND_TYPE,
        })
        .then((res) => {
          let stonefilter = res.data?.result?.filter((s) => s.FL_STATUS != "A");
          if (stonefilter > 0) {
            alert(
              stonefilter?.map((s) => s.FL_STATUS).join(",") +
                "Item is not available"
            );
          } else {
            let obj = res.data?.result?.map((item) => ({
              ...item,
              TYPE: "NEW",
              FL_STONE_ID: item?.FL_STONE_ID,
              FL_SHAPE: item?.FL_SHAPE,
              FL_COLOR: item?.FL_COLOR,
              FL_RAP: item?.FL_RAP,
              FL_CARATS: item?.FL_CARATS,
              FL_PCS: item?.FL_PCS,
              FL_DISC: item?.FL_DISC,
            }));
            setJeweleryDetail([...jeweleryDetail, ...obj]);
          }
        });
    }
  };
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileInputChange = (event) => {
    const files = event.target.files;
    const file = event.target.files[0];
    const reader = new FileReader();
    if (!file) {
      return;
    }
    reader.onload = (e) => {
      const UNITdata = new Uint8Array(e.target.result);
      const workbook = XLSX.read(UNITdata, { type: "array" });

      // Assuming the first sheet is the one you want to convert
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to JSON format
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      // const result =
      let REOBJ = [];
      if (formikRef?.current?.values?.FL_DIAMOND_TYPE == "POLISH-SINGLE") {
        REOBJ = jsonData.map((stone) => ({
          FL_STONE_ID: stone["STONE"],
          FL_WGT: stone["CARATS"],
          FL_RAP_PRICE_US: stone["RAP"],
          FL_SALEDISC: stone["DISC"],
          FL_SALERATE: stone["STONE"],
          FL_AMT1: stone["AMT($)"],
          FL_AMT2: stone["AMT(RMB)"],
        }));
      } else {
        REOBJ = jsonData.map((stone) => ({
          FL_STONE_ID: stone["LOT.NO."],
          FL_WGT: stone["CARATS"],
          FL_PCS: stone["PCS"],
          FL_AMT2: stone["AMT(RMB)"],
        }));
      }

      // const REOBJ = jsonData.slice(1).map(row => {
      //   const obj = {};
      //   jsonData[0].forEach((key, index) => {
      //     obj[`${getFieldName(key.trim())}`] = row[index];
      //   });
      //   return { ...obj, Edited: true, FL_ID: `new-${obj.FL_SUB_LOT}-${obj.FL_MAIN_LOT}` };
      // });
      setStoneDetail([...stoneDetail, ...REOBJ]);
      fileInputRef.current.value = "";
    };

    reader.readAsArrayBuffer(file);
    // console.log(files);
    // Handle the file upload logic here...
  };

  const handleJewerlyFileInputChange = (event) => {
    const files = event.target.files;
    const file = event.target.files[0];
    const reader = new FileReader();
    if (!file) {
      return;
    }
    reader.onload = (e) => {
      const UNITdata = new Uint8Array(e.target.result);
      const workbook = XLSX.read(UNITdata, { type: "array" });

      // Assuming the first sheet is the one you want to convert
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to JSON format
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      // const result =
      let REOBJ = [];
      if (formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY") {
        REOBJ = jsonData.map((stone) => ({
          FL_STONE_ID: stone["FL_STONE_ID"],
          FL_SHAPE: stone["FL_SHAPE"],
          FL_COLOR: stone["FL_COLOR"],
          FL_RAP: stone["FL_RAP"],
          FL_CARATS: stone["FL_CARATS"],
          FL_PCS: stone["FL_PCS"],
          FL_DISC: stone["FL_DISC"],
          FL_AMT1: stone["FL_AMT1"],
          FL_AMT2: stone["FL_AMT2"],
        }));
      } else {
        REOBJ = jsonData.map((stone) => ({
          FL_STONE_ID: stone["LOT.NO."],
          FL_WGT: stone["CARATS"],
          FL_PCS: stone["PCS"],
          FL_AMT2: stone["AMT(RMB)"],
        }));
      }

      setJeweleryDetail([...jeweleryDetail, ...REOBJ]);
      fileInputRef.current.value = "";
    };

    reader.readAsArrayBuffer(file);
  };
  useEffect(() => {
    const sumAMT2 = stoneDetail.reduce((acc, obj) => acc + obj.FL_AMT2, 0);
    const sumWGT = stoneDetail.reduce((acc, obj) => acc + obj.FL_WGT, 0);
    const sumRAP =
      stoneDetail.reduce((acc, obj) => acc + obj.FL_RAP_PRICE_US, 0) /
      stoneDetail.length;

    setStoneDetailEgerDetails({ sumAMT2, sumWGT, sumRAP });
  }, [stoneDetail]);

  const handleClickOpen = (e, values) => {
    fetchAdvanceData(values);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePaidAmountChange = (e, OAMT, index) => {
    setadvanvedPaidamt({
      ...advanvedPaidamt,
      [e.target.name]:
        e.target.value <= Number(OAMT) ? Number(e.target.value) : Number(OAMT),
    });
  };

  const advanceTotals = Object.values(advanvedPaidamt)
    .reduce((total, value) => {
      if (!isNaN(parseFloat(value))) {
        return total + parseFloat(value);
      } else {
        return total;
      }
    }, 0)
    ?.toFixed(2);

  return (
    <>
      <Stack justifyContent={"end"} direction={"row"} spacing={3}>
        <Tooltip title="Jewelry Sample File">
          <Link to={`${BACKEND_APP_URL}demo/AC_JE_OT.xlsx`} target="_blank">
            <Avatar>
              <svg
                width="20"
                height="20"
                viewBox="0 0 693 800"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M162.479 62.1786C165.143 64.8427 169.139 67.5053 173.134 67.5053C175.798 67.5053 178.461 66.174 179.793 66.174C186.453 62.1786 187.784 54.1878 183.789 47.5282L157.152 7.57403C153.157 0.914482 145.166 -0.416804 138.506 3.57862C133.18 7.57403 131.847 15.5649 135.842 22.2244L162.479 62.1786Z"
                  fill="white"
                />
                <path
                  d="M625.948 174.05C629.943 174.05 632.607 172.719 635.27 170.055L675.224 130.101C680.551 124.774 680.551 116.783 675.224 111.455C669.897 106.128 661.906 106.128 656.578 111.455L616.624 151.409C611.297 156.736 611.297 164.727 616.624 170.055C619.29 172.719 621.952 174.05 625.948 174.05Z"
                  fill="white"
                />
                <path
                  d="M49.2781 111.455C43.9514 106.128 35.9606 106.128 30.6323 111.455C25.3041 116.782 25.3056 124.773 30.6323 130.101L70.5865 170.055C73.2507 172.719 75.9132 174.05 79.9086 174.05C83.9041 174.05 86.5682 172.719 89.2308 170.055C94.5575 164.728 94.5575 156.737 89.2308 151.409L49.2781 111.455Z"
                  fill="white"
                />
                <path
                  d="M511.415 64.843C514.079 66.1743 516.742 67.5071 519.406 67.5071C523.401 67.5071 527.397 64.843 530.061 60.8476L556.698 20.8934C560.692 14.2338 559.36 6.24298 552.701 2.24756C546.041 -1.74786 538.05 -0.416573 534.055 6.24298L507.418 46.1972C503.424 52.8567 504.756 60.8476 511.415 64.843Z"
                  fill="white"
                />
                <path
                  d="M531.389 740.069C527.393 733.41 519.403 732.078 512.743 736.074C506.083 740.069 504.752 748.06 508.748 754.72L535.384 794.674C538.048 797.338 542.044 800 546.039 800C548.703 800 551.366 798.669 554.03 798.669C560.69 794.674 562.021 786.683 558.025 780.023L531.389 740.069Z"
                  fill="white"
                />
                <path
                  d="M57.2656 630.859L17.3114 670.813C11.9847 676.14 11.9847 684.131 17.3114 689.459C19.9756 692.123 22.6381 693.455 26.6336 693.455C30.629 693.455 33.2931 692.123 35.9557 689.459L75.9099 649.505C81.2366 644.178 81.2366 636.188 75.9099 630.859C70.5832 625.533 62.5923 625.533 57.2656 630.859Z"
                  fill="white"
                />
                <path
                  d="M621.953 630.859C616.627 625.533 608.636 625.533 603.308 630.859C597.981 636.186 597.981 644.177 603.308 649.505L643.262 689.459C645.926 692.123 648.588 693.455 652.584 693.455C656.579 693.455 659.243 692.123 661.906 689.459C667.233 684.133 667.233 676.142 661.906 670.813L621.953 630.859Z"
                  fill="white"
                />
                <path
                  d="M179.796 734.741C173.136 730.745 165.145 732.077 161.15 738.736L134.513 778.69C130.518 785.35 131.849 793.341 138.509 797.336C141.173 798.667 143.835 800 146.499 800C150.495 800 154.49 797.336 157.154 793.341L183.791 753.387C187.786 746.727 186.454 738.736 179.796 734.741Z"
                  fill="white"
                />
                <path
                  d="M346.267 67.5053C354.258 67.5053 359.584 62.1786 359.584 54.1878V14.2336C359.584 6.24272 354.258 0.916016 346.267 0.916016C338.276 0.916016 332.949 6.24272 332.949 14.2336V54.1878C332.949 62.1786 338.276 67.5053 346.267 67.5053Z"
                  fill="white"
                />
                <path
                  d="M346.267 733.409C338.276 733.409 332.949 738.736 332.949 746.727V786.681C332.949 794.672 338.276 799.998 346.267 799.998C354.258 799.998 359.584 794.672 359.584 786.681V746.727C359.586 738.736 354.258 733.409 346.267 733.409Z"
                  fill="white"
                />
                <path
                  d="M13.3175 333.868H53.2717C61.2626 333.868 66.5893 328.541 66.5893 320.55C66.5893 312.559 61.2626 307.232 53.2717 307.232H13.3175C5.32671 307.232 0 312.559 0 320.55C0 328.541 5.32671 333.868 13.3175 333.868Z"
                  fill="white"
                />
                <path
                  d="M53.2717 507.001C61.2626 507.001 66.5893 501.675 66.5893 493.684C66.5893 485.693 61.2626 480.366 53.2717 480.366H13.3175C5.32671 480.366 0 485.693 0 493.684C0 501.675 5.32671 507.001 13.3175 507.001H53.2717Z"
                  fill="white"
                />
                <path
                  d="M639.267 307.23C631.276 307.23 625.949 312.557 625.949 320.548C625.949 328.539 631.276 333.866 639.267 333.866H679.221C687.212 333.866 692.539 328.539 692.539 320.548C692.539 312.557 687.212 307.23 679.221 307.23H639.267Z"
                  fill="white"
                />
                <path
                  d="M679.221 480.366H639.267C631.276 480.366 625.949 485.693 625.949 493.684C625.949 501.675 631.276 507.001 639.267 507.001H679.221C687.212 507.001 692.539 501.675 692.539 493.684C692.539 485.693 687.212 480.366 679.221 480.366Z"
                  fill="white"
                />
                <path
                  d="M584.662 592.744V202.019C585.388 199.843 585.302 197.674 584.662 195.714V195.359L584.454 195.117C583.9 193.713 583.062 192.428 581.998 191.364L502.089 98.138C501.531 97.5793 500.903 97.0939 500.24 96.6522L498.094 94.1426H193.111L106.543 195.359V605.556L107.954 607.206C108.291 607.988 108.686 608.77 109.207 609.552L189.115 702.778C189.674 703.336 190.302 703.822 190.965 704.263L193.111 706.773H499.427L517.692 684.798L583.331 608.22C585.995 605.556 587.326 601.561 585.995 597.565C585.993 595.888 585.502 594.224 584.662 592.744ZM197.106 576.257L235.729 614.88L198.439 670.816L141.172 604.225L197.106 576.257ZM258.369 600.23L213.088 554.949V247.301L259.702 200.688H434.169L456.81 223.329L479.451 245.97V554.949L434.17 600.23H258.369ZM495.432 576.257L551.367 604.225L494.1 670.816L456.81 614.88L495.432 576.257ZM495.432 224.66L456.809 186.037L494.099 130.101L551.366 196.692L495.432 224.66ZM432.393 174.051H261.476L225.961 120.779H467.905L432.393 174.051ZM198.438 130.101L235.728 186.037L197.105 224.66L141.183 196.7L169.802 163.398L198.438 130.101ZM133.18 221.996L186.451 248.633V551.618L133.18 578.255V221.996ZM260.145 626.865H432.393L467.908 680.136H224.631L260.145 626.865ZM506.085 551.618V247.3L560.689 219.998V578.92L506.085 551.618Z"
                  fill="white"
                />
                <path
                  d="M438.165 441.744C438.165 399.126 392.884 376.486 391.551 376.486C379.565 368.495 372.906 360.504 371.574 349.849C367.579 327.208 387.556 299.24 395.547 289.918C399.542 285.923 400.873 279.263 396.878 273.936C392.883 268.61 386.223 265.945 380.896 268.61C375.57 269.941 253.043 319.219 253.043 440.413C253.043 492.353 294.328 533.639 346.269 533.639C398.211 533.639 439.498 492.353 438.165 441.744ZM346.27 507.002C308.98 507.002 279.68 477.703 279.68 440.411C279.68 379.149 318.303 339.194 350.266 316.553C346.27 327.208 343.606 340.526 346.27 353.843C350.266 372.489 360.921 387.138 380.898 399.124C380.898 399.124 412.861 415.106 412.861 440.41C412.861 477.703 383.562 507.002 346.27 507.002Z"
                  fill="white"
                />
              </svg>
              {/* <img
                      src="images/svgs/jewely.svg"
                      style={{ width: "30px", height: "30px", stroke:"#e7eaed"}}
                    /> */}
            </Avatar>
          </Link>
        </Tooltip>
        <Tooltip title="DownLoad Parcel Sample file">
          <Link
            to={`${BACKEND_APP_URL}demo/ACC_DIAMOND_OUTWARD_SHEET_POLISH_PARCEL.xlsx`}
            target="_blank"
          >
            <Avatar>
              <Download />
            </Avatar>
          </Link>
        </Tooltip>
        <Tooltip title="DownLoad Single Sample file">
          <Link
            to={`${BACKEND_APP_URL}demo/ACC_DIAMOND_OUTWARD_SHEET.xlsx`}
            target="_blank"
          >
            <Avatar>
              <DiamondIcon />
            </Avatar>
          </Link>
        </Tooltip>
      </Stack>
      <Formik
        initialValues={initialValues}
        innerRef={formikRef}
        validationSchema={outwardvalidationSchema}
        onSubmit={handleSubmitData}
      >
        {({
          values,
          resetForm,
          setFieldValue,
          validateForm,
          isSubmitting,
          errors,
          touched,
        }) => (
          <>
            {" "}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <InputLabel>Select Party</InputLabel>
                <Field
                  size="small"
                  name="FL_PARTY_CODE"
                  InputLabel="Select Bank"
                  as={Select}
                  fullWidth
                >
                  {editabletrdetail?.PARTY?.map((item) => (
                    <MenuItem
                      key={item.FL_PARTY_CODE}
                      value={item.FL_PARTY_CODE}
                    >
                      {item.FL_PARTY_NAME}
                    </MenuItem>
                  ))}
                </Field>
                {errors.FL_PARTY_CODE && (
                  <div className="error">{errors.FL_PARTY_CODE}</div>
                )}
              </Grid>
              <Grid item xs={12} lg={6}>
                <InputLabel>Select Bank</InputLabel>
                <Field
                  size="small"
                  name="FL_BANK_CODE"
                  InputLabel="Select Bank"
                  as={Select}
                  fullWidth
                >
                  <MenuItem value="">Select Select Bank</MenuItem>
                  {editabletrdetail?.leadgerdetail?.map((item) => (
                    <MenuItem key={item.ACODE} value={item.ACODE}>
                      {item.ANAME}
                    </MenuItem>
                  ))}
                </Field>
                {errors.FL_BANK_CODE && (
                  <div className="error">{errors.FL_BANK_CODE}</div>
                )}
              </Grid>
              <Grid item xs={12} lg={3}>
                <Field
                  name="FL_CURR_CODE"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Currency Type"
                  fullWidth
                >
                  {editabletrdetail?.CURR?.map((option) => (
                    <MenuItem
                      key={option.FL_CURRENCY_ID}
                      fname={option.FL_CURRENCY_NAME}
                      value={option.FL_CURRENCY_ID}
                    >
                      {option.FL_CURRENCY_NAME}
                    </MenuItem>
                  ))}
                </Field>
                {errors.FL_CURR_CODE && (
                  <div className="error">{errors.FL_CURR_CODE}</div>
                )}
              </Grid>
              <Grid item xs={12} lg={3}>
                <Field
                  name="FL_CONV_RATE"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  type="number"
                  label="Conv Rate"
                  fullWidth
                />
                {errors.FL_CONV_RATE && (
                  <div className="error">{errors.FL_CONV_RATE}</div>
                )}
              </Grid>
              <Grid item xs={12} lg={6}>
                <Field
                  name="FL_TERM_CODE"
                  as={TextField}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  style={{ margin: "5px 0" }}
                  select
                  label="Payment Term"
                  fullWidth
                >
                  {editabletrdetail?.TERM?.map((option) => (
                    <MenuItem
                      key={option.FL_TERM_CODE}
                      color="primary"
                      value={option.FL_TERM_CODE}
                    >
                      {option.FL_TERM_NAME}
                    </MenuItem>
                  ))}
                </Field>
                {errors.FL_TERM_CODE && (
                  <div className="error">{errors.FL_TERM_CODE}</div>
                )}
              </Grid>
            </Grid>
            <Grid container columnSpacing={2}>
              <Grid item xs={3}>
                {/* <InputLabel>Select INVENTORY type</InputLabel> */}
                <Field
                  name="FL_DIAMOND_TYPE"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Select Diamond"
                  fullWidth
                  disabled={
                    stoneDetail?.length > 0 || jeweleryDetail?.length > 0
                  }
                >
                  <MenuItem value="">Select INVENTORY</MenuItem>
                  {editabletrdetail?.INVETORYTYPE.map((item) => (
                    <MenuItem value={item.NAME}>{item.NAME}</MenuItem>
                  ))}
                </Field>
                {errors.FL_DIAMOND_TYPE && (
                  <div className="error">{errors.FL_DIAMOND_TYPE}</div>
                )}
              </Grid>
              <Grid item xs={12} lg={3}>
                <Field
                  name="FL_SHIP_BY"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Ship By"
                  fullWidth
                >
                  {editabletrdetail?.SHIPPEDBY?.map((option) => (
                    <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                      {option.FL_PARA_VALUE}
                    </MenuItem>
                  ))}
                </Field>
                {errors.FL_SHIP_BY && (
                  <div className="error">{errors.FL_SHIP_BY}</div>
                )}
              </Grid>
              <Grid item xs={12} lg={6}>
                <Field
                  name="FL_TRANS_DATE"
                  as={TextField}
                  type="date"
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Date"
                  fullWidth
                />
                {errors.FL_TRANS_DATE && (
                  <div className="error">{errors.FL_TRANS_DATE}</div>
                )}
              </Grid>
              <Grid item xs={12} lg={6}>
                <Field
                  name="FL_WAT_PER"
                  value={editabletrdetail?.TAX?.FL_TAX_PER}
                  disabled
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Vat Charge(%)"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <Field
                  name="FL_SHIPING_CHRGES"
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Shiping Charge(AMT)"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <Field
                  name="FL_CERTIFICATE_CHARGES"
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Cert. Charge(AMT)"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <Field
                  name="FL_OTHER_CHRGES"
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="OtherCharge(AMT)"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <Field
                  name="FL_DISCOUNT_CHRGES"
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Discount(-AMT)"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  sx={{ display: "block", marginLeft: "auto", mt: 3 }}
                  disabled={
                    values?.FL_PARTY_CODE == "" || values?.FL_CURR_CODE == ""
                  }
                  onClick={(e) => {
                    handleClickOpen(e, values);
                  }}
                >
                  Advanced Bil({advanceTotals})
                </LoadingButton>
              </Grid>
            </Grid>
            <InputLabel>Naration</InputLabel>
            <Field
              size="small"
              component={TextareaAutosize}
              name="FL_NARRATION"
              label="Naration"
              minRows={3}
              onChange={(e) => setFieldValue("FL_NARRATION", e.target.value)}
              style={{ width: "100%" }}
              fullWidth
            />
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={
                formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY"
                  ? handleJewerlyFileInputChange
                  : handleFileInputChange
              }
            />
            <Div sx={{ textAlign: "end" }}>
              {" "}
              {formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY" && (
                <LoadingButton
                  loading={isSubmitting}
                  variant="contained"
                  color="primary"
                  sx={{ marginLeft: "auto", mt: 3, mr: 3 }}
                  onClick={addItemHandler}
                >
                  ADD Item
                </LoadingButton>
              )}
              <LoadingButton
                loading={isSubmitting}
                variant="contained"
                color="primary"
                sx={{ marginLeft: "auto", mt: 3 }}
                disabled={!values?.FL_CONV_RATE}
                onClick={handleUploadClick}
              >
                Upload Data
              </LoadingButton>
              {formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                "POLISH-SINGLE" && (
                <LoadingButton
                  loading={isSubmitting}
                  variant="contained"
                  color="primary"
                  sx={{ marginLeft: "auto", mt: 3, ml: 2 }}
                  onClick={addstoneHandler}
                >
                  ADD Stone
                </LoadingButton>
              )}
            </Div>
            {stoneDetail.length > 0 && (
              <TableContainer sx={{ mt: 3 }} component={Paper}>
                <Table border={1} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>StoneID</TableCell>
                      <TableCell>WGT</TableCell>
                      {formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                        "POLISH-SINGLE" && (
                        <>
                          {" "}
                          <TableCell>Rap</TableCell>
                          <TableCell>Disc</TableCell>
                        </>
                      )}
                      <TableCell>Rate($)</TableCell>
                      <TableCell>AMT($)</TableCell>
                      <TableCell>AMT(RMB)</TableCell>
                      {/* <TableCell>Is Approved</TableCell> */}
                      <TableCell align="right">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stoneDetail.map((st, index) => (
                      <TableRow
                        sx={{ bgcolor: st.TYPE == "NEW" && "#3153721f" }}
                        key={st.FL_STONE_ID}
                      >
                        <TableCell>{st.FL_STONE_ID}</TableCell>
                        <TableCell>{st.FL_WGT?.toFixed(2)}</TableCell>
                        {formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                          "POLISH-SINGLE" && (
                          <>
                            <TableCell>
                              {st.FL_RAP_PRICE_US?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {(
                                100 -
                                ((st.FL_AMT2 /
                                  values?.FL_CONV_RATE /
                                  st.FL_WGT) *
                                  100) /
                                  st.FL_RAP_PRICE_US
                              )?.toFixed(2)}
                            </TableCell>
                          </>
                        )}
                        <TableCell>
                          {(
                            st.FL_AMT2 /
                            values?.FL_CONV_RATE /
                            st.FL_WGT
                          )?.toFixed(2)}
                        </TableCell>
                        <TableCell>
                          {(st.FL_AMT2 / values?.FL_CONV_RATE)?.toFixed(2)}
                        </TableCell>
                        <TableCell>
                          {editingIndex === st.FL_STONE_ID ? (
                            <Input
                              value={editedValues["FL_AMT2"]}
                              type="number"
                              onChange={(e) =>
                                handleInputChange("FL_AMT2", e.target.value)
                              }
                            />
                          ) : (
                            st.FL_AMT2?.toFixed(2)
                          )}
                        </TableCell>
                        <TableCell align="right" width={180}>
                          {editingIndex === st.FL_STONE_ID ? (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handleSaveButtonClick}
                            >
                              Save
                            </Button>
                          ) : (
                            <>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() =>
                                  handleCellDoubleClick(
                                    st.FL_STONE_ID,
                                    "FL_AMT2",
                                    st.FL_AMT2
                                  )
                                }
                              >
                                Edit
                              </Button>
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{ ml: 1 }}
                                onClick={() => HandleRemoveCell(st.FL_STONE_ID)}
                              >
                                Delete
                              </Button>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell>Total</TableCell>
                      <TableCell>
                        {stoneDetailEgerDetails?.sumWGT?.toFixed(2)}
                      </TableCell>
                      {formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                        "POLISH-SINGLE" && (
                        <>
                          <TableCell>
                            {stoneDetailEgerDetails?.sumRAP?.toFixed(2)}
                          </TableCell>
                          <TableCell>
                            {(
                              100 -
                              ((stoneDetailEgerDetails?.sumAMT2 /
                                values?.FL_CONV_RATE /
                                stoneDetailEgerDetails?.sumWGT) *
                                100) /
                                stoneDetailEgerDetails?.sumRAP
                            )?.toFixed(2)}
                          </TableCell>
                        </>
                      )}
                      <TableCell>
                        {(
                          stoneDetailEgerDetails?.sumAMT2 /
                          values?.FL_CONV_RATE /
                          stoneDetailEgerDetails?.sumWGT
                        )?.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {(
                          stoneDetailEgerDetails?.sumAMT2 / values?.FL_CONV_RATE
                        )?.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {stoneDetailEgerDetails?.sumAMT2?.toFixed(2)}
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={
                          formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                          "POLISH-SINGLE"
                            ? 5
                            : 3
                        }
                      >
                        Tax/Charges
                      </TableCell>
                      <TableCell>
                        {(
                          ((stoneDetailEgerDetails?.sumAMT2 *
                            editabletrdetail?.TAX?.FL_TAX_PER) /
                            100 +
                            Number(values?.FL_SHIPING_CHRGES || 0) +
                            Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                            Number(values?.FL_OTHER_CHRGES || 0) -
                            Number(values?.FL_DISCOUNT_CHRGES || 0)) /
                          values?.FL_CONV_RATE
                        )?.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {(
                          (stoneDetailEgerDetails?.sumAMT2 *
                            editabletrdetail?.TAX?.FL_TAX_PER) /
                            100 +
                          Number(values?.FL_SHIPING_CHRGES || 0) +
                          Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                          Number(values?.FL_OTHER_CHRGES || 0) -
                          Number(values?.FL_DISCOUNT_CHRGES || 0)
                        )?.toFixed(2)}
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={
                          formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                          "POLISH-SINGLE"
                            ? 6
                            : 3
                        }
                      >
                        Gross Total
                      </TableCell>

                      <TableCell>
                        {(
                          (Number(stoneDetailEgerDetails?.sumAMT2) || 0) +
                          (Number(stoneDetailEgerDetails?.sumAMT2 || 0) *
                            (Number(editabletrdetail?.TAX?.FL_TAX_PER) || 0)) /
                            100 +
                          Number(values?.FL_SHIPING_CHRGES || 0) +
                          Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                          Number(values?.FL_OTHER_CHRGES || 0) -
                          Number(values?.FL_DISCOUNT_CHRGES || 0)
                        ).toFixed(2)}
                      </TableCell>

                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {jeweleryDetail.length > 0 && (
              <TableContainer sx={{ mt: 3 }} component={Paper}>
                <Table border={1} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item Code</TableCell>
                      {formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                        "JEWELRY" && (
                        <>
                          <TableCell>Shape</TableCell>
                          <TableCell>Color</TableCell>
                          <TableCell>Rap</TableCell>
                          <TableCell>Carats</TableCell>
                          <TableCell>Pcs</TableCell>
                          <TableCell>Disc</TableCell>
                        </>
                      )}
                      <TableCell>AMT($)</TableCell>
                      <TableCell>AMT(RMB)</TableCell>
                      <TableCell align="right">Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {jeweleryDetail.map((item, index) => (
                      <TableRow
                        sx={{ bgcolor: item.TYPE == "NEW" && "#3153721f" }}
                        key={item.FL_STONE_ID}
                      >
                        {formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                          "JEWELRY" && (
                          <>
                            <TableCell>{item.FL_STONE_ID}</TableCell>
                            <TableCell>{item.FL_SHAPE}</TableCell>
                            <TableCell>{item.FL_COLOR}</TableCell>
                            <TableCell>{item?.FL_RAP}</TableCell>
                            <TableCell>{item?.FL_CARATS}</TableCell>
                            <TableCell>{item?.FL_PCS}</TableCell>
                            <TableCell>{item?.FL_DISC}</TableCell>
                          </>
                        )}
                        <TableCell>{item?.FL_AMT1?.toFixed(2)}</TableCell>
                        <TableCell>
                          {editingItemIndex === item.FL_STONE_ID ? (
                            <Input
                              value={editedItemvalues["FL_AMT2"]}
                              type="number"
                              onChange={(e) =>
                                handleItemInputChange("FL_AMT2", e.target.value)
                              }
                            />
                          ) : (
                            item?.FL_AMT2?.toFixed(2)
                          )}
                        </TableCell>
                        <TableCell align="right" width={180}>
                          {editingItemIndex === item.FL_STONE_ID ? (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handleSaveItemButtonClick}
                            >
                              Save
                            </Button>
                          ) : (
                            <>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() =>
                                  handleItemCellDoubleClick(
                                    item.FL_STONE_ID,
                                    "FL_AMT2",
                                    editedItemvalues["FL_AMT2"]
                                  )
                                }
                              >
                                Edit
                              </Button>
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{ ml: 1 }}
                                onClick={() =>
                                  HandleItemRemoveCell(item.FL_STONE_ID)
                                }
                              >
                                Delete
                              </Button>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell
                        colSpan={
                          formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                          "JEWELRY"
                            ? 7
                            : 3
                        }
                      >
                        Total
                      </TableCell>
                      <TableCell>
                        {jeweleryDetail
                          ?.filter((item) => item.FL_AMT1)
                          .reduce(
                            (total, item) => total + parseFloat(item.FL_AMT1),
                            0
                          )
                          ?.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {jeweleryDetail
                          ?.filter((item) => item.FL_AMT2)
                          .reduce(
                            (total, item) => total + parseFloat(item.FL_AMT2),
                            0
                          )
                          ?.toFixed(2)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={
                          formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                          "JEWELRY"
                            ? 7
                            : 3
                        }
                      >
                        Tax/Charges
                      </TableCell>
                      <TableCell>
                        {(
                          ((jeweleryDetail
                            ?.filter((item) => item.FL_AMT1)
                            .reduce(
                              (total, item) => total + parseFloat(item.FL_AMT1),
                              0
                            ) *
                            editabletrdetail?.TAX?.FL_TAX_PER) /
                            100 +
                            Number(values?.FL_SHIPING_CHRGES || 0) +
                            Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                            Number(values?.FL_OTHER_CHRGES || 0) -
                            Number(values?.FL_DISCOUNT_CHRGES || 0)) /
                          values?.FL_CONV_RATE
                        )?.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {(
                          (jeweleryDetail
                            ?.filter((item) => item.FL_AMT2)
                            .reduce(
                              (total, item) => total + parseFloat(item.FL_AMT2),
                              0
                            ) *
                            editabletrdetail?.TAX?.FL_TAX_PER) /
                            100 +
                          Number(values?.FL_SHIPING_CHRGES || 0) +
                          Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                          Number(values?.FL_OTHER_CHRGES || 0) -
                          Number(values?.FL_DISCOUNT_CHRGES || 0)
                        )?.toFixed(2)}
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={
                          formikRef?.current?.values?.FL_DIAMOND_TYPE ==
                          "JEWELRY"
                            ? 8
                            : 3
                        }
                      >
                        Gross Total
                      </TableCell>
                      <TableCell>
                        {(
                          jeweleryDetail
                            ?.filter((item) => item.FL_AMT2)
                            .reduce(
                              (total, item) => total + parseFloat(item.FL_AMT2),
                              0
                            ) +
                          (jeweleryDetail
                            ?.filter((item) => item.FL_AMT2)
                            .reduce(
                              (total, item) => total + parseFloat(item.FL_AMT2),
                              0
                            ) *
                            editabletrdetail?.TAX?.FL_TAX_PER) /
                            100 +
                          Number(values?.FL_SHIPING_CHRGES || 0) +
                          Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                          Number(values?.FL_OTHER_CHRGES || 0) -
                          Number(values?.FL_DISCOUNT_CHRGES || 0)
                        )?.toFixed(2)}
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <LoadingButton
              loading={isSubmitting}
              variant="contained"
              color="primary"
              sx={{ display: "block", marginLeft: "auto", mt: 3 }}
              disabled={
                formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY"
                  ? !jeweleryDetail.length > 0
                  : !stoneDetail.length > 0
              }
              type="submit"
              onClick={async () => {
                const calculateJewTax = () => {
                  const jewTax = (
                    (jeweleryDetail
                      ?.filter((item) => item.FL_AMT2)
                      .reduce(
                        (total, item) => total + parseFloat(item.FL_AMT2),
                        0
                      ) *
                      editabletrdetail?.TAX?.FL_TAX_PER) /
                      100 +
                    Number(values?.FL_SHIPING_CHRGES || 0) +
                    Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                    Number(values?.FL_OTHER_CHRGES || 0) -
                    Number(values?.FL_DISCOUNT_CHRGES || 0)
                  )?.toFixed(2);
                  return jewTax;
                };
                const calculateTax = () => {
                  const Tax = (
                    (stoneDetailEgerDetails?.sumAMT2 *
                      editabletrdetail?.TAX?.FL_TAX_PER) /
                      100 +
                    Number(values?.FL_SHIPING_CHRGES || 0) +
                    Number(values?.FL_CERTIFICATE_CHARGES || 0) +
                    Number(values?.FL_OTHER_CHRGES || 0) -
                    Number(values?.FL_DISCOUNT_CHRGES || 0)
                  )?.toFixed(2);
                  return Tax;
                };
                const jewTax = calculateJewTax();
                const tax = calculateTax();
                let totalTax =
                  formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY"
                    ? jewTax
                    : tax;
                let totalItems =
                  formikRef?.current?.values?.FL_DIAMOND_TYPE == "JEWELRY"
                    ? jeweleryDetail
                        ?.filter((item) => item.FL_AMT2)
                        .reduce(
                          (total, item) => total + parseFloat(item.FL_AMT2),
                          0
                        )
                        ?.toFixed(2)
                    : stoneDetailEgerDetails?.sumAMT2?.toFixed(2);
                let totalResult = Number(totalItems) + Number(totalTax);
                if (
                  Number(totalResult)?.toFixed(2) <
                  Number(advanceTotals)?.toFixed(2)
                ) {
                  alert(
                    "Advanced bill should be less than or equal to total bill, Yore advanced amount is"+advanceTotals
                  );
                } else {
                  JSON.stringify(await validateForm()) == JSON.stringify({}) &&
                    handleSubmitData(values);
                }
              }}
            >
              Save
            </LoadingButton>
          </>
          //  </Form>
        )}
      </Formik>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Advanced Bil
        </DialogTitle>
        <DialogContent>
          {advanceData.length > 0 && (
            <TableContainer sx={{ mt: 3 }} component={Paper}>
              <Table border={1} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>TransNo</TableCell>
                    <TableCell>TransDate</TableCell>
                    <TableCell>Adv Amt</TableCell>
                    <TableCell>Os Amt</TableCell>
                    <TableCell>Paid Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {advanceData?.map((st, index) => (
                    <TableRow key={st.FL_TRANSNO}>
                      <TableCell>{st.FL_TRANSNO}</TableCell>
                      <TableCell>
                        {moment(st.FL_TRANS_DATE).format("DD/MM/YYYY")}
                      </TableCell>
                      <TableCell>{st?.AMT?.toFixed(2) || 0}</TableCell>
                      <TableCell>{st?.OAMT?.toFixed(2) || 0}</TableCell>

                      <TableCell align="center">
                        <TextField
                          size="small"
                          type="number"
                          id={index}
                          name={st?.FL_TRANSNO}
                          value={
                            advanvedPaidamt[st?.FL_TRANSNO]
                              ? advanvedPaidamt[st?.FL_TRANSNO] < st?.OAMT
                                ? advanvedPaidamt[st?.FL_TRANSNO]
                                : st?.OAMT
                              : 0
                          }
                          //id={`input-${index}-${index}`}
                          //id={`input-1-${index}`}
                          min={0}
                          inputProps={{
                            step: 0.01,
                            max: st?.OAMT,
                          }}
                          sx={{ minWidth: 150 }}
                          onInput={(e) =>
                            handlePaidAmountChange(e, st?.OAMT, index)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Div sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Div>
      )}
    </div>
  );
};
const TABRECIPIENT = { E: 0, P: 1, S: 2 };
const BooKBill = () => {
  const { billID, ETYPE, TRTYPE } = useParams();
  const theme = useTheme();

  const [value, setValue] = React.useState(TABRECIPIENT[ETYPE] || 0);
  const [FRMVAL, setFRMVAL] = React.useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };
  useEffect(async () => {
    if (FRMVAL?.master?.CNT > 0) {
      setValue(4);
      alert(
        "This Transaction is Memo in R/C You Can't Edit You Can Delete Entire Trasanction"
      );
    }
  }, [FRMVAL]);
  useEffect(async () => {
    (ETYPE == "P" || ETYPE == "S") &&
      (await jwtAuthAxios
        .post("acc/getbookentrydetail", { billID, ETYPE, TRTYPE })
        .then((res) => {
          setFRMVAL(res.data);
        })
        .catch(alert));
  }, []);
  useEffect(async () => {
    if(FRMVAL?.master?.CNT > 0){
      setValue(4);
      alert('in R/C You Can\'t Edit You Can Delete Entire Trasanction')
    }
      }, [FRMVAL])
  
  return (
    <Paper spacing={0} style={{ padding: 0 }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="Reciept Tabs"
        >
          <Tab disabled={ETYPE} label="Expence Entry" {...a11yProps(0)} />
          <Tab disabled={ETYPE} label="Purchase Entry" {...a11yProps(1)} />
          <Tab disabled={ETYPE} label="Sale Entry" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Expensebill />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          {(billID && FRMVAL) || !billID ? (
            <InwardBook FRMVAL={FRMVAL} />
          ) : (
            "Loading..."
          )}
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          {(billID && FRMVAL) || !billID ? (
            <OutwardBook FRMVAL={FRMVAL} />
          ) : (
            "Loading..."
          )}
        </TabPanel>
      </SwipeableViews>
    </Paper>
  );
};

BooKBill.Modulename = "expensepayment";
export default BooKBill;
